import { createTheme } from '@mui/material/styles';

export const idexTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#12131b',
      paper: '#1a1c26',
    },
    primary: {
      main: '#c42ebe',
      light: '#f72bef',
      dark: '#a4069d',
    },
    secondary: {
      main: '#00b8ff',
      light: '#00ddff',
      dark: '#007fbf',
    },
    text: {
      primary: '#ffffff',
      secondary: '#cacce5',
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, #212229 0%, #12131b 100%)',
          borderBottom: '1px solid #333',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1a1c26',
          borderRight: '1px solid #333',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
        },
      },
    },
  },
});
